import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { type Observable } from 'rxjs';
import type { Consent } from '../models/consent.enum';
import { environment } from '../environments/environment';

export interface ConsentPreference {
  consent: Consent;
  choice: boolean;
}

export interface SavePreferencesPayload {
  token: string;
  preferences: ConsentPreference[];
}

@Injectable({
  providedIn: 'root',
})
export class OptOutService {
  constructor(private readonly http: HttpClient) {}

  /**
   * API base URL for the current environment.
   * - dev/tst/acc: https://<stage>.api.optout.nonprod-app.essent.nl
   * - prd: https://api.optout.app.essent.nl
   */
  private get apiBaseUrl(): string {
    const { stage } = environment;
    if (stage === 'prd') {
      return 'https://prd.api.optout.app.essent.nl';
    }
    return `https://${stage}.api.optout.nonprod-app.essent.nl`;
  }

  /**
   * Save email preferences
   * @param payload Object containing token and preferences array
   * @returns Observable that completes when save is successful
   */
  public savePreferences(payload: SavePreferencesPayload): Observable<void> {
    const url = `${this.apiBaseUrl}/consent`;
    return this.http.post<void>(url, payload);
  }
}
